import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardImageConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:image';

  override async prepareBlock(
    image: BlockSnapshot
  ): Promise<PreparedEdgelessBlock | null> {
    const {
      xywh,
      rotate,
      sourceId,
      size,
      width,
      height,
      name,
      caption,
      presentation,
      sourceCaption,
      type,
    } = image.props;

    if (!this.surface) return null;

    if (!(await this.std.workspace.blobSync.get(sourceId as string))) {
      return null;
    }
    // The blob is checked before the paste writes; the write itself is
    // synchronous, in the transaction of the whole paste.
    return {
      create: () => {
        const surface = this.surface;
        if (!surface) return null;
        return this.crud.addBlock(
          'affine:image',
          {
            caption,
            sourceId,
            xywh,
            rotate,
            size,
            width,
            height,
            name,
            presentation,
            sourceCaption,
            type,
          },
          surface.model.id
        );
      },
    };
  }
}
